import { render, staticRenderFns } from "./budgetDia.vue?vue&type=template&id=efb0df56&scoped=true"
import script from "./budgetDia.vue?vue&type=script&lang=js"
export * from "./budgetDia.vue?vue&type=script&lang=js"
import style0 from "./budgetDia.vue?vue&type=style&index=0&id=efb0df56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb0df56",
  null
  
)

export default component.exports